import Vue from 'vue';
import App from './App.vue';
import router from './router';
import qs from 'qs';
// import 'default-passive-events';

// element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
/* 引入swiper */
// import Swiper from 'swiper';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
// Vue.use(Swiper);
Vue.use(VueAwesomeSwiper /* { default options with global component } */ );

// animate
import animated from 'animate.css';
Vue.use(animated);

// import 'lib-flexible/flexible'

//可拖拽表格
import ComplexGrid from "complex-grid";
Vue.use(ComplexGrid);

//cookie
import cookie from "vue-cookie";
Vue.use(cookie);

Vue.prototype.$qs = qs;

Vue.config.productionTip = false;

new Vue({
  // 全局事件总线
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
  router,
  render: h => h(App),
}).$mount('#app');